var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showImage)?_c('img',_vm._g({class:['gl-avatar', { 'gl-avatar-circle': _vm.isCircle }, _vm.sizeClasses],attrs:{"src":_vm.src,"alt":_vm.alt},on:{"error":_vm.handleLoadError}},_vm.$listeners)):_c('div',_vm._g({class:[
    'gl-avatar gl-avatar-identicon',
    { 'gl-avatar-circle': _vm.isCircle },
    _vm.sizeClasses,
    _vm.identiconBackgroundClass,
  ],attrs:{"aria-hidden":"true"}},_vm.$listeners),[_vm._v("\n  "+_vm._s(_vm.identiconText)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }